import React, { useState } from 'react';
import './Projects.css';

const Projects = () => {
  const [selectedFilter, setSelectedFilter] = useState('all');

  const projects = [
    {
      id: 1,
      name: 'Yadadri Enclave',
      location: 'Yadagirigutta',
      certification: null,
      status: 'completed'
    },
    {
      id: 2,
      name: 'Gokula Nagar',
      location: 'Yadagirigutta',
      certification: null,
      status: 'completed'
    },
    {
      id: 3,
      name: 'Yasaswi Elite',
      location: 'Aler',
      certification: 'DTCP Completed',
      status: 'completed'
    },
    {
      id: 4,
      name: 'My Homes',
      location: 'Ghatkesar',
      certification: 'HMDA',
      status: 'completed'
    },
    {
      id: 5,
      name: 'Siri County',
      location: 'Ghatkesar',
      certification: 'HMDA',
      status: 'completed'
    },
    {
      id: 6,
      name: 'Agra Vanam',
      location: 'Aler, Kolanupaka',
      certification: null,
      status: 'completed'
    },
    {
      id: 7,
      name: 'Prakruthi Vanam',
      location: 'Aler, Kolanupaka',
      certification: null,
      status: 'completed'
    },
    {
      id: 8,
      name: 'Sri Gandha Vanam',
      location: 'Aler',
      certification: null,
      status: 'completed'
    },
    {
      id: 9,
      name: 'Siri County',
      location: 'Jain Mandir',
      certification: 'DTCP',
      status: 'completed'
    },
    {
      id: 10,
      name: 'Siri Vanam',
      location: 'Masaipet, Yadagirigutta',
      certification: null,
      status: 'completed'
    },
    {
      id: 11,
      name: 'Maha Vanam',
      location: 'Aler, Yadadri',
      certification: 'Infra',
      status: 'ongoing',
      isFlagship: true
    }
  ];

  const filteredProjects = selectedFilter === 'all' 
    ? projects 
    : projects.filter(p => p.status === selectedFilter);

  const ongoingProject = projects.find(p => p.status === 'ongoing');
  const completedProjects = projects.filter(p => p.status === 'completed');

  return (
    <section className="projects">
      {/* Eyebrow */}
      <div className="projects-eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">Portfolio</span>
        <div className="eyebrow-line"></div>
      </div>

      {/* Main Heading */}
      <h1 className="projects-title">
        Our <em>Landmark Projects</em>
      </h1>

      {/* Subtitle */}
      <p className="projects-subtitle">
        Transforming landscapes across Hyderabad with 11 exceptional residential communities
      </p>

      {/* Flagship Project - Maha Vanam */}
      {ongoingProject && (
        <div className="flagship-section">
          <div className="flagship-badge">
            <span className="flagship-label">Flagship Project</span>
          </div>
          <div className="flagship-card">
            <div className="flagship-content">
              <div className="flagship-header">
                <h2 className="flagship-title">{ongoingProject.name}</h2>
                <div className="status-badges">
                  <span className="badge badge-ongoing">Ongoing</span>
                  <span className="badge badge-booking">Booking Open</span>
                </div>
              </div>
              <p className="flagship-location">
                <span className="location-icon">📍</span>
                {ongoingProject.location}
              </p>
              {ongoingProject.certification && (
                <div className="certification-badge cert-infra">
                  {ongoingProject.certification}
                </div>
              )}
              <p className="flagship-description">
                Our most ambitious venture yet, Maha Vanam represents the pinnacle of modern residential 
                living in Aler and Yadadri. Strategic location, premium infrastructure, and exceptional 
                community planning make this our flagship development. Join us in building the future.
              </p>
              <button className="flagship-cta">Learn More</button>
            </div>
            <div className="flagship-visual">
              <div className="placeholder-image">
                <span>Maha Vanam</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Filter Tabs */}
      <div className="filter-tabs">
        <button
          className={`filter-btn ${selectedFilter === 'all' ? 'active' : ''}`}
          onClick={() => setSelectedFilter('all')}
        >
          All Projects ({projects.length})
        </button>
        <button
          className={`filter-btn ${selectedFilter === 'completed' ? 'active' : ''}`}
          onClick={() => setSelectedFilter('completed')}
        >
          Completed ({completedProjects.length})
        </button>
      </div>

      {/* Projects Grid */}
      <div className="projects-grid">
        {filteredProjects.map((project) => (
          <div key={project.id} className="project-card">
            <div className="project-card-header">
              <h3 className="project-name">{project.name}</h3>
              {project.status === 'ongoing' && (
                <span className="project-badge ongoing">Ongoing</span>
              )}
            </div>

            <div className="project-location">
              <span className="location-icon">📍</span>
              {project.location}
            </div>

            {project.certification && (
              <div className={`certification-badge cert-${project.certification.toLowerCase().replace(/\s+/g, '-')}`}>
                {project.certification}
              </div>
            )}

            <div className="project-footer">
              <a href="/projects" className="project-link">Explore Project →</a>
            </div>
          </div>
        ))}
      </div>

      {/* Stats Section */}
      <div className="projects-stats">
        <h2>Our Development Scale</h2>
        <div className="stats-container">
          <div className="stat-item">
            <div className="stat-number">11</div>
            <div className="stat-label">Projects</div>
            <p className="stat-description">Completed and ongoing developments</p>
          </div>
          <div className="stat-item">
            <div className="stat-number">800+</div>
            <div className="stat-label">Acres</div>
            <p className="stat-description">Land developed across premium locations</p>
          </div>
          <div className="stat-item">
            <div className="stat-number">6</div>
            <div className="stat-label">Prime Locations</div>
            <p className="stat-description">Strategically selected across Hyderabad</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="projects-cta">
        <h2>Find Your Perfect Home</h2>
        <p>Explore our diverse portfolio and discover the perfect residential community for your lifestyle.</p>
        <button className="cta-button">Schedule a Site Visit</button>
      </div>
    </section>
  );
};

export default Projects;
